// extracted by mini-css-extract-plugin
module.exports = {"tiktokEmbed":"style_tiktokEmbed__CnBcD","fallback":"style_fallback__6ieb_ g-grid-container"};